import React from 'react';
import PropTypes from 'prop-types';
import test4 from '../Images/widget_clicktocall.png'
import { margin } from '@mui/system';

const Popup = ({ message, handleConfirm, onCancel, style }) => {

  const popupStyle = {
    backgroundColor: '#F2F7FF',
    padding: '20px',
    borderRadius: '5px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    borderRadius: "20px",
    width: "280px",
    position: 'absolute',
    zIndex: '100',
    ...style,
    margin:"-150px 40px"
  };


  const arrowStyle = {
    // position: 'absolute',
    // width: '0',
    // height: '0',
    // borderLeft: '10px solid transparent',
    // borderRight: '10px solid transparent',
    // borderBottom: '10px solid #f4e6ed',
    // top: '-10px',
    // left: '50%',
    // transform: 'translateX(-50%)',
    position: 'absolute',
    width: '0',
    height: '0',
    // borderLeft: '10px solid transparent',
    borderRight: '51px solid transparent',
    borderTop: '26px solid #F2F7FF', // Adjust this to point upwards
    bottom: '-20px', // Position it at the bottom
    left: '57%',
    transform: 'translateX(-50%)'
  };

  const messageStyle = {
    marginBottom: '20px',
  };

  const buttonsStyle = {
    display: 'flex',
    justifyContent: 'space-around',
  };

  const buttonStyle = {
    padding: '5px 10px',
    backgroundColor: '#256EFF',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '10px',
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3',
  };

  return (
    <div style={popupStyle}>
      <div style={arrowStyle}></div>
      <div style={{ display: "flex" }}>
        <div>
          <img src={test4} alt="help" style={{ width: "90px", height: "90px" }} />
        </div>
        <div>
          <div style={messageStyle}> Do you need help in filling out the form ?</div>
          <div style={buttonsStyle}>
            <button
              style={buttonStyle}
              onMouseOver={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)}
              onMouseOut={(e) => (e.target.style.backgroundColor = buttonStyle.backgroundColor)}
              onClick={(e) => {
                e.preventDefault();
                handleConfirm();
              }}
            >
              Yes
            </button>
            <button
              style={buttonStyle}
              onMouseOver={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)}
              onMouseOut={(e) => (e.target.style.backgroundColor = buttonStyle.backgroundColor)}
              onClick={(e) => {
                e.preventDefault();
                onCancel();
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

Popup.propTypes = {
  message: PropTypes.string.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default Popup;